module.exports = __webpack_public_path__ + "static/media/raiahui-intro.8550c76c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/raiahui-intro.jpg
// module id = 232
// module chunks = 0